import { Badge } from "@/components/ui/badge";
import { Crown, Gem, StarIcon } from "lucide-react";

const PointsBadge = ({
  className = "",
  points,
  completed,
}: { className?: string; points?: number; completed?: boolean }) => {
  if (!points || points === 0) {
    return null;
  }
  return (
    <Badge
      title="Leaderboard Points"
      className={className}
      variant={completed ? "completed" : "outline"}
      startIcon={<StarIcon className="w-4 h-4" />}
    >
      {points}
    </Badge>
  );
};

const GemsBadge = ({
  className = "",
  text,
  gems,
  completed,
}: {
  className?: string;
  text?: string;
  gems?: number;
  completed?: boolean;
}) => {
  if ((!gems || gems === 0) && !text) {
    return null;
  }
  return (
    <Badge
      title="Gems"
      className={className}
      variant={completed ? "completed" : "outline"}
      startIcon={<Gem className="w-4 h-4" />}
    >
      {text || gems}
    </Badge>
  );
};

const WeeklyPointsBadge = ({
  className = "",
  text,
  points,
  completed,
}: {
  className?: string;
  text?: string;
  points?: number;
  completed?: boolean;
}) => {
  if ((!points || points === 0) && !text) {
    return null;
  }
  return (
    <Badge
      title="Weekly Points"
      className={className}
      variant={completed ? "completed" : "outline"}
      startIcon={<Crown className="w-4 h-4" />}
    >
      {text || points}
    </Badge>
  );
};

const PerpetualRewardsBadge = ({
  hasCampaignPoints,
}: { hasCampaignPoints: boolean }) => {
  return (
    <div className="flex items-center gap-1">
      <span className="text-xs bg-gradient-text bg-clip-text text-transparent font-normal leading-4">
        {hasCampaignPoints ? "Leaderboard + Weekly Rewards" : "Weekly Rewards"}
      </span>
    </div>
  );
};

export { PointsBadge, GemsBadge, PerpetualRewardsBadge, WeeklyPointsBadge };
